import { Compass } from 'lucide-react';
import { ButtonLink, EmptyState } from '@/components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <EmptyState
        icon={<Compass size={20} aria-hidden="true" />}
        title="Page not found"
        description="The page you are looking for does not exist."
        action={<ButtonLink to="/categories">Back to Categories</ButtonLink>}
      />
    </div>
  );
}
